export default __webpack_public_path__ + "static/EYInterstateRegular-35edb9910680577817408d5676629a48.woff2";